import {a1MaterialsDefaults} from '../utils/A1MaterialsSection';
import {a3ManufacturingDefaults} from '../utils/A3ManufacturingSection';
import {bUseDefaults} from '../utils/BUseSection';
import {cEndOfLifeDefaults} from '../utils/CEndOfLifeSection';
import {productionDataDefaults} from '../utils/ProductionDataSection';
import {
  outboundTransportDefaults,
  transportDefaults
} from '../utils/TransportSection';

export const lciFormInitialValues = {
  production: productionDataDefaults,
  a1: a1MaterialsDefaults,
  a2: transportDefaults,
  a3: a3ManufacturingDefaults,
  a4: outboundTransportDefaults,
  b: bUseDefaults,
  c: cEndOfLifeDefaults
};

export type LciFormTabKey =
  | 'production'
  | 'a1'
  | 'a2'
  | 'a3'
  | 'a4'
  | 'b'
  | 'c';

export const LCI_FIELD_PREFIX_TO_SUBTAB: Record<
  LciFormTabKey,
  'prod' | 'a1' | 'a2' | 'a3' | 'a4' | 'b' | 'c'
> = {
  production: 'prod',
  a1: 'a1',
  a2: 'a2',
  a3: 'a3',
  a4: 'a4',
  b: 'b',
  c: 'c'
};
